






































































































































import UpDownIcon from "../../../components/UpDownIcon.vue";
import StatusChip from "../../../components/StatusChip.vue";
import PartnerSearch from "@/modules/partner/views/PartnerSearch.vue";
import IconButton from "@/components/IconButton.vue";
import Fragment from "@/components/Fragment.vue";
import BankExtractImportItemDetails from "./BankExtractImportItemDetails.vue";

import Vue from "vue";
import BankExtractImportApi from "../services/BankExtractImportApi";
import store, { BankExtractImportStore } from "../services/BankExtractImportStore";
import BankExtractImport from "../models/BankExtractImport";
import { getAltRow } from "@/utils/classes";
import Partner, { PartnerResponse } from "@/modules/partner/models/Partner";
import PartnerApi from "@/modules/partner/services/PartnerApi";
import BankExtractImportItem from "../models/BankExtractImportItem";
import AccountSubtype from "@/modules/accountType/models/AccountSubtype";
import PartBankCreator from "./PartBankCreator.vue";
import eventBus from "@/services/eventBus";

interface Data {
  store: BankExtractImportStore;
  loaded: boolean;
  partnerSearchFirstPage: PartnerResponse | null;
  ownPartnerID: number;
}

interface Methods {
  setTypesAutomatically(): void;
  typeCopy(item: BankExtractImportItem): void;
  partnerChanged(item: BankExtractImportItem, partner: Partner): void;
  typeChanged(item: BankExtractImportItem): void;
  getSubtypes(item: BankExtractImportItem): AccountSubtype[];
  getAltRow(index: number): string;
  showPartBankCreate(item: BankExtractImportItem): void;
}

interface Props {
    head: BankExtractImport;
    edit: boolean;
}

export default Vue.extend<Data, Methods, {}, Props>({
  components: {
    UpDownIcon,
    StatusChip,
    PartnerSearch,
    IconButton,
    Fragment,
    BankExtractImportItemDetails,
    PartBankCreator
  },

  props: {
    head: { type: Object as () => BankExtractImport },
    edit: Boolean,
  },

  data: (): Data => ({
    store,
    loaded: false,
    partnerSearchFirstPage: null,
    ownPartnerID: 1,
  }),

  async beforeMount() {
    if (this.edit) {
      this.partnerSearchFirstPage = await PartnerApi.getAllGeneral(1, 10, false);
    }

    if (!this.edit && (!this.head.items || this.head.items.length == 0)) {
      this.head.items = await BankExtractImportApi.getItems(this.head.id);
    }

    if (this.ownPartnerID < 2){
        this.ownPartnerID = await PartnerApi.getOwnPartnerIdFromSysFile();
    }

    console.log(this.head.items);

    this.loaded = true;
  },

  methods: {
    showPartBankCreate(item) {
      if (item.partnerID < 2) {
        eventBus.$emit("error", "Kérem előbb válasszon partnert!");
      } else {
        item.partBankCreate = !item.partBankCreate
      }
    },

    async setTypesAutomatically(){
      if (this.ownPartnerID < 2){
        this.ownPartnerID = await PartnerApi.getOwnPartnerIdFromSysFile();
      }

      const invoicePay = this.store.itemTypes.find(x => x.name.toUpperCase() == "SZÁMLAKIEGYENLÍTÉS")
      const subTypes = this.store.itemSubtypes.filter(x => x.type == invoicePay?.id);

      const crediting = subTypes.find(x => x.name.toUpperCase() == "SZÁMLAKIEGYENLÍTÉS (VEVŐI)");
      const charge = subTypes.find(x => x.name.toUpperCase() == "SZÁMLAKIEGYENLÍTÉS (SZÁLLÍTÓI)");

      this.head.items.forEach(x => {
        if (x.typeID < 2 && x.partnerID != this.ownPartnerID){
          if (x.actionType === 'Jóváírás'){
            x.typeID = invoicePay?.id ?? 1;
            x.subtypeID = crediting?.id ?? 1;
          } else {
            x.typeID = invoicePay?.id ?? 1;
            x.subtypeID = charge?.id ?? 1;
          }
        }
      });
    },

    typeCopy(item: BankExtractImportItem){
      this.head.items.forEach(x => {
        x.typeID = item.typeID;
        x.subtypeID = item.subtypeID;
      });
    },

    partnerChanged(item: BankExtractImportItem, partner: Partner) {
      item.partnerAddress = partner.postCode + " " + partner.invoiceCity + ", " + partner.invoiceAddress;
      item.partnerTaxAccount = partner.taxAccount;
    },

    typeChanged(item: BankExtractImportItem): void {
      item.subtypeID = this.getSubtypes(item).filter((x) => x.id > 1)[0]?.id ?? 1;
    },

    getSubtypes(item: BankExtractImportItem): AccountSubtype[] {
      return this.store.itemSubtypes.filter((x) => x.id === 1 || x.type === item.typeID);
    },

    getAltRow,
  },

  computed: {
    items(){
      return this.head.items;
    }
  },

  watch: {
    items: function(){
      this.setTypesAutomatically();
    }
  }
});
